/**
 * Vertical Scroll Gallery Animation Controller
 * Handles dynamic CSS custom property updates for smooth scrolling animations
 */
class VerticalScrollGallery {
  constructor(element) {
    this.gallery = element;
    this.columnCount = parseInt(element.dataset.columnCount) || 2;
    this.imageCount = parseInt(element.dataset.imageCount) || 0;
    this.init();
  }

  init() {
    if (this.imageCount === 0) return;
    
    this.updateAnimationProperties();
    this.setupIntersectionObserver();
  }

  updateAnimationProperties() {
    // Calculate animation distance based on image count
    const scrollImagesSeconds = this.imageCount * 2;
    const scrollImagesCount = this.imageCount / 2;
    const keyframeAnimation = `calc((${scrollImagesCount} * 100%) * -1)`;
    
    // Apply CSS custom properties to the gallery
    this.gallery.style.setProperty('--scroll-images-seconds', scrollImagesSeconds);
    this.gallery.style.setProperty('--keyframe-animation', keyframeAnimation);
    
    // Update all gallery images with the calculated values
    const galleryImages = this.gallery.querySelectorAll('.gallery-image');
    galleryImages.forEach(image => {
      image.style.setProperty('--scroll-images-seconds', scrollImagesSeconds);
      image.style.setProperty('--keyframe-animation', keyframeAnimation);
    });
  }

  setupIntersectionObserver() {
    // Pause animations when not in viewport for performance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const images = entry.target.querySelectorAll('.gallery-image');
        if (entry.isIntersecting) {
          images.forEach(img => img.style.animationPlayState = 'running');
        } else {
          images.forEach(img => img.style.animationPlayState = 'paused');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });

    observer.observe(this.gallery);
  }
}

// Initialize galleries when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('.vertical-scroll-gallery');
  galleries.forEach(gallery => new VerticalScrollGallery(gallery));
});

// Re-initialize on theme editor updates
document.addEventListener('shopify:section:load', (event) => {
  const galleries = event.target.querySelectorAll('.vertical-scroll-gallery');
  galleries.forEach(gallery => new VerticalScrollGallery(gallery));
});
